export enum AssembleiaStatus {
  NaoDisponivel = 0,
  Pre = 1,
  Live = 2,
  Pos = 3,
  Encerrado = 4,
  EncerradoSemQuorum = 5,
}

export enum StatusMensagens {
  Bloqueado = 0,
  LiberadoConvocados = 1,
  LiberadoTodos = 2,
}
